import { PRIVILEGES } from './privileges.const';

export const PRIVILEGES_PER_FEATURE = {
  /** User Feature */
  Users: {
    Details: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },
    ChangePhoneNumber: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    ShowPairingQRCode: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    FrontendEvents: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    UserAuditLogs: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    Devices: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    LockUser: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },

    ResetPassword: {
      prod: [
        PRIVILEGES.GS_MA,
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_START,
        PRIVILEGES.TEAM_GIRO,
        PRIVILEGES.TEAM_EXELA,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.PAYLIFE_ADMIN_PRD,
        PRIVILEGES.KLAR_ADMIN_PRD,
        PRIVILEGES.EASY_ADMIN_PRD,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },
  },

  /** Push Notifications Feature */
  PushNotifications: {
    TemplateManagement: {
      prod: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      ],
      test: [
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },
  },

  /** App Maintenance */
  AppMaintenance: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** Feature Flags feature */
  FeatureFlags: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** Frontend Events feature */
  FrontendEvents: {
    prod: [
      PRIVILEGES.GS_MA,
      PRIVILEGES.FILIALLEITER_ALL,
      PRIVILEGES.CC_START,
      PRIVILEGES.TEAM_GIRO,
      PRIVILEGES.TEAM_EXELA,
      PRIVILEGES.CC_SUPERVISOR,
      PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
      PRIVILEGES.CSC_PROZESS_INFO,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.PAYLIFE_ADMIN_PRD,
      PRIVILEGES.KLAR_ADMIN_PRD,
      PRIVILEGES.EASY_ADMIN_PRD,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** User Audit Logs feature*/
  UserAuditLogs: {
    prod: [
      PRIVILEGES.GS_MA,
      PRIVILEGES.FILIALLEITER_ALL,
      PRIVILEGES.CC_START,
      PRIVILEGES.TEAM_GIRO,
      PRIVILEGES.TEAM_EXELA,
      PRIVILEGES.CC_SUPERVISOR,
      PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
      PRIVILEGES.CSC_PROZESS_INFO,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.PAYLIFE_ADMIN_PRD,
      PRIVILEGES.KLAR_ADMIN_PRD,
      PRIVILEGES.EASY_ADMIN_PRD,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** Banners Management */
  Banners: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CRM_MANAGER,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CRM_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  EndOfWorldBanner: {
    prod: [PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** Labels Management */
  Labels: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },

  /** API Threats Monitoring */
  ApiThreats: {
    prod: [
      PRIVILEGES.AAD_LINUX_AKS_ADMIN,
      PRIVILEGES.LIBRA_OPERATOR,
      PRIVILEGES.AAD_GITHUB_LIBRA_OPERATIONS_TEAM,
    ],
    test: [
      PRIVILEGES.AAD_LINUX_AKS_ADMIN,
      PRIVILEGES.LIBRA_OPERATOR,
      PRIVILEGES.AAD_GITHUB_LIBRA_OPERATIONS_TEAM,
    ],
  },

  /** Admin Tab Access */
  AdminTab: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.KLAR_ADMIN_UAT,
    ],
  },

  /** EBanking Disposers */
  EbankingDisposers: {
    MtanToggle: {
      prod: [
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      ],
      test: [
        PRIVILEGES.FILIALLEITER_ALL,
        PRIVILEGES.CC_SUPERVISOR,
        PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
        PRIVILEGES.CSC_PROZESS_INFO,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
        PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
        PRIVILEGES.EASY_ADMIN_UAT,
        PRIVILEGES.KLAR_ADMIN_UAT,
        PRIVILEGES.PAYLIFE_ADMIN_TST,
      ],
    },
  },

  /** Customer Tab Access */
  CustomerTab: {
    prod: [
      PRIVILEGES.GS_MA,
      PRIVILEGES.FILIALLEITER_ALL,
      PRIVILEGES.TEAM_GIRO,
      PRIVILEGES.TEAM_EXELA,
      PRIVILEGES.CC_SUPERVISOR,
      PRIVILEGES.BESCHWERDE_MANAGEMENT_TEAM,
      PRIVILEGES.CSC_PROZESS_INFO,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.KLAR_ADMIN_UAT,
    ],
  },

  /** Shield feature */
  Shield: {
    prod: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
    ],
    test: [
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_TEST,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_RELEASE_MANAGER,
      PRIVILEGES.AAD_ADMIN_CONSOLE_CHANNELS_ADMIN,
      PRIVILEGES.EASY_ADMIN_UAT,
      PRIVILEGES.KLAR_ADMIN_UAT,
      PRIVILEGES.PAYLIFE_ADMIN_TST,
    ],
  },
};
